import { motion } from "framer-motion";

import Container from "../../Container/Container";
import SectionTitle from "../../SectionTitle/SectionTitle";
import { fadeUp, staggerContainer, viewportOnce } from "../../../Utils/animations";
import { getIcon } from "../../../Utils/iconMap";
import { processSteps } from "../../../Data/processData";

import "../../../Style/home/process.css";

/** Four-step timeline — a real sequence, so numbering is warranted here. */
function Process() {
  return (
    <section className="section section--deep-tint process">
      <Container>
        <SectionTitle
          eyebrow="Our Working Process"
          title="How we turn data into"
          highlight="opportunity."
          align="center"
        />

        <motion.div
          className="process__track"
          variants={staggerContainer(0.14)}
          initial="hidden"
          whileInView="show"
          viewport={viewportOnce}
        >
          <motion.span
            className="process__line"
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={viewportOnce}
            transition={{ duration: 1.1, ease: "easeInOut" }}
          />

          {processSteps.map((step) => (
            <motion.div key={step.id} className="process__step" variants={fadeUp()}>
              <span className="process__icon">{getIcon(step.icon, 22)}</span>
              <span className="process__number">{step.number}</span>
              <h3 className="process__title">{step.title}</h3>
              <p className="card__text">{step.description}</p>
            </motion.div>
          ))}
        </motion.div>
      </Container>
    </section>
  );
}

export default Process;
